// Format currency values
export const formatCurrency = (value, currency = 'USD', decimals = 2) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value)
}

// Format large numbers (e.g., volume)
export const formatVolume = (value) => {
  if (value >= 1e9) {
    return `${(value / 1e9).toFixed(2)}B`
  }
  if (value >= 1e6) {
    return `${(value / 1e6).toFixed(2)}M`
  }
  if (value >= 1e3) {
    return `${(value / 1e3).toFixed(2)}K`
  }
  return value.toString()
}

// Format percentage change
export const formatPercentage = (value, showSign = true) => {
  const sign = showSign && value > 0 ? '+' : ''
  return `${sign}${value.toFixed(2)}%`
}

// Format date for charts
export const formatChartDate = (date, timeframe = '1D') => {
  const d = new Date(date)
  
  switch (timeframe) {
    case '1D':
      return d.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })
    case '1W':
      return d.toLocaleDateString('en-US', { weekday: 'short' })
    case '1M':
      return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
    case '1Y':
      return d.toLocaleDateString('en-US', { month: 'short' })
    default:
      return d.toLocaleDateString()
  }
}

// Get price change color class
export const getPriceChangeColor = (change) => {
  if (change > 0) return 'text-white'
  if (change < 0) return 'text-gray-400'
  return 'text-gray-500'
}

// Get price change background color
export const getPriceChangeBg = (change) => {
  if (change > 0) return 'bg-white/10 border border-white/20'
  if (change < 0) return 'bg-charcoal-800 border border-charcoal-700'
  return 'bg-gray-800/50 border border-gray-700'
}
